module.exports = __webpack_public_path__ + "static/getStarted_junior_mobile-41cb783b2e81ca6454263e32959acdd5.svg";